var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgContactRecruiter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.1463H22.9867C21.92 25.1463 20.9067 25.5596 20.16 26.3063L17.88 28.5597C16.84 29.5863 15.1467 29.5863 14.1067 28.5597L11.8267 26.3063C11.08 25.5596 10.0533 25.1463 9 25.1463H8C5.78667 25.1463 4 23.373 4 21.1864V6.63965C4 4.45298 5.78667 2.67969 8 2.67969H24C26.2133 2.67969 28 4.45298 28 6.63965V21.1864C28 23.3597 26.2133 25.1463 24 25.1463Z",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 13.3334C17.715 13.3334 19.106 11.9425 19.106 10.2267C19.106 8.51096 17.715 7.12012 15.9993 7.12012C14.2835 7.12012 12.8926 8.51096 12.8926 10.2267C12.8926 11.9425 14.2835 13.3334 15.9993 13.3334Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3327 20.8798C21.3327 18.4798 18.946 16.5332 15.9993 16.5332C13.0527 16.5332 10.666 18.4798 10.666 20.8798",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContactRecruiter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/contact-recruiter.7a850721.svg";
export { ForwardRef as ReactComponent };